/*eslint-disable */
import { FunctionComponent, useEffect, useMemo, useState } from "react";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { IAmount } from "./Amount";
import { panDeclaration, roundOffValue, selectVendor, transactionDetails } from "../../store";
import { BlueDivision, CrossIcon, DownIcon, Equal, InfoIcon, Plus, Telegram } from "../../assets/Icons";
import { UserTransactionDetails } from "../../store/store";
import { additionalDocumentsList, formatNumber, getSendMoneyErrorMessage, lastTwoDecimal } from "../../utils";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import MoneyReceive from "../../assets/Icons/MoneyReceive";
import { toast, ToastContainer } from "react-toastify";
import Button from "../../components/ui/Button";
import { Axios } from "../../services/axios";
import download from "downloadjs";
import { getVendorCode } from "../../services/purposeCode";
import { set } from "cypress/types/lodash";
import ShareQuoteModal from "../../components/ui/Modal/ShareQuoteModal";

export const PaymentDetails: FunctionComponent<IAmount.PaymentDetailsProps> = ({
  nostro,
  setNostro,
  handlePanBasedClick,
  setIsModalOpen,
  setPan,
  setIsPanModelOpen,
  pan,
  purposeCode,
  setIsErrorPresent,
  // handleGeneralClick,
  loading,
  isErrorPresent,
  sendingAmount,
  destCurrency,
  proceedClick,
  recievingAmount,
  rate,
  purposeValue,
  setTempPan,
  setShowQuoteModal,
  showQuoteModal
}) => {
  const transactionData: UserTransactionDetails = useRecoilValue(transactionDetails);
  const selected = "rounded px-2 text-white bg-primary-1050";
  const deselcted = "rounded border px-2 text-black bg-[#E3E3E3]";
  const [taxStep, setTaxStep] = useState<boolean>(true);
  const [showOur, setShowOur] = useState<boolean>(true);
  const [roundOffVal, setRoundOffVal] = useRecoilState(roundOffValue);
  const [panDeclarationValue, setPanDeclarationValue] = useRecoilState(panDeclaration);
  const [showInfo, setShowInfo] = useState<boolean>(false);
  const [vendorCode, setVendorCode] = useRecoilState(selectVendor);
  const [data, setData] = useState<any>([]);
  const [message, setMessage] = useState<string>("");


  const purposeCodes = ["S1301", "S1302"];
  useMemo(() => {
    setShowOur(!(purposeCode === "S1301" || purposeCode === "S1302"));
    if (purposeCodes?.includes(purposeCode)) {
      setRoundOffVal(false);
    }
  }, [purposeCode]);

  useEffect(() => {
    getVendorCode()
      .then((res: any) => {
        setData(res?.data);
      })
      .catch((error) => {
        console.error("ERROR", error);
      });
  }, []);

  const totalPay =
    transactionData.total_tax +
    transactionData.nostro_charges +
    transactionData.nostro_charges_new +
    transactionData.hop_fees +
    transactionData.tcs;

  const nostroHandler = () => {
    const code = purposeCode
    if (code === "S1301" || code === "S1302") {
      setNostro("bene");
    } else {
      setNostro(nostro === "our" ? "bene" : "our");
    }
  };


  const payValue = useMemo(() => {
    return roundOffVal
      ? transactionData?.totalPayInCeils?.find((item: any) => item.id === 10).total_pay
      : transactionData?.total_pay;
  }, [roundOffVal, transactionData]);

  const vendorFee = useMemo(() => {
    return roundOffVal
      ? transactionData?.totalPayInCeils?.find((item: any) => item.id === 10).hop_fee
      : transactionData?.hop_fees;
  }, [roundOffVal, transactionData]);


  const handleDownloadQuoteClick = async () => {
    let vendor_code;
    data
      .filter(
        (item: { displayName: string | null; userId: string; vendorCode: string }) =>
          item.vendorCode === vendorCode?.vendorCode,
      )
      .map((item: { displayName: string | null; userId: string; vendorCode: string }) => {
        vendor_code = item.userId;
      });

    const purpose = additionalDocumentsList.find((item) => item.name === purposeValue)?.code;
    const userId = localStorage.getItem("userKey") || "{}";
    const Money_you_send = sendingAmount.toString();
    const Money_they_receive = recievingAmount.toString();
    const Exchange_rate = rate.toString();

    const totalTaxes_charges =
      transactionData.total_tax +
      transactionData.nostro_charges +
      transactionData.nostro_charges_new +
      transactionData.hop_fees +
      transactionData.tcs;
    const totalFees = totalTaxes_charges.toString();
    const youPay = parseFloat(Money_you_send) + parseFloat(totalFees);
    if (!sendingAmount || !recievingAmount || !rate || !vendor_code || !purpose) {
      toast.error("TO DOWNLOAD QUOTE, FILL VENDORCODE AND PURPOSECODE");
      return;
    }

    const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
    try {
      const response = await Axios.get(`remit/user/${userId}/quote`, {
        params: {
          transVendorKey: vendorCode?.userId,
          destinationCurrency: destCurrency,
          conversionRate: Exchange_rate,
          recipientReceive: Money_they_receive,
          taxes: transactionData.total_tax,
          totalPay: youPay,
          purposeCode: purpose,
          userSend: sendingAmount,
          tcs: transactionData.tcs,
          bankFee: transactionData.nostro_charges,
          nostro: transactionData.nostro_charges_new,
          vendorFee: transactionData.hop_fees,
        },
        headers: {
          Authorization: `${currentUser.idToken}`,
        },
        responseType: "blob",
      });
      if (response?.status === 200) {
        const content = response.headers["content-type"];
        setMessage("Your file is ready to be downloaded successfully.");
        setTimeout(() => {
          download(response.data, "User Quote.pdf", content);
          setMessage("");
        }, 3000);
      } else {
        if (
          response.data &&
          response.data.error &&
          response.data.error.code === 2000 &&
          response.data.error.type === "User Send cannot be less than 5000"
        ) {
          console.log("User Send cannot be less than 5000");
        }
        toast.error(`${response?.data?.error?.type}`);
      }
    } catch (error: any) {
      // Check if the error response contains the expected error structure
      if (error.data && error.data.error) {
        toast.error(`${error.data.error.type}`);
      } else {
        // General error handling
        toast.error("Download failed, please try again later");
      }
    }
  };

  const panBasedSelected =
    "w-fit p-2 flex flex-row items-center justify-center text-primary-1050 font-bold  hover:scale-105 transition-all underline cursor-pointer";
  const panBasedNotSelected =
    "w-fit py-2 px-1 flex items-center justify-center rounded text-primary-1050 font-bold :scale-105 transition-all text-[#0F13F1] cursor-pointer underline";

  return (
    <div className=" h-full">
      <div className="justify-center">
      </div>
      {/* <div className=" w-[300px] h-[50px] flex cursor-pointer rounded -mt-36 ml-[-35%]"> */}
      {/* <div
          onClick={() => {
            setIsModalOpen("");
            setIsPanModelOpen(false);
            setPan("");
            setPanDeclarationValue("");
            setIsErrorPresent(false);
            // handleGeneralClick && handleGeneralClick();
          }}
          className={pan === "" ? panBasedSelected : panBasedNotSelected}
        >
          General
        </div> */}
      {/* <div
          onClick={handlePanBasedClick}
          className={pan === "" ? panBasedNotSelected : panBasedSelected}
        >
          Declaration
        </div> */}
      {/* </div> */}
      <div className="mb-5 text-black text-[30px] font-semibold font-ssp">Calculation</div>
      <div className="flex items-center justify-between gap-5">
        <div className="border border-gray-200 rounded-md p-8 w-[560px] h-[620px] shadow-xl">
          <div className="flex items-center justify-around mb-8">
            <div className="flex flex-col flex-1 ">
              <div className="flex items-center justify-between mb-0">
                <div className="flex items-center space-x-2 text-xs font-bold text-black lg:text-base">
                  <div className="mr-3 rotate-180">
                    <DownIcon fillColor="rotate-90" />
                  </div>
                  You Send
                </div>
                {loading ? (
                  <Skeleton width={100} height="100%" />
                ) : (
                  <div className="flex items-center justify-between space-x-4">
                    <div className="text-xs font-bold text-black lg:text-base">
                      {formatNumber(transactionData.user_send)}
                    </div>
                    <div className="text-xs font-bold text-black lg:text-base">INR</div>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="flex items-center justify-between mb-8">
            <div className="bg-neutral-900 w-8 h-8 rounded-full flex items-center justify-center shadow-sm">
              <svg
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                width="20"
                height="20"
              >
                <path
                  stroke="#FFFFFF"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 17h12M4 17l3.5-3.5M4 17l3.5 3.5M7 7h13m0 0l-3.5-3.5M20 7l-3.5 3.5"
                />
              </svg>
            </div>
            <div className="flex items-center justify-between flex-1 ml-5">
              <div className="-ml-2 text-xs font-bold text-black lg:text-base">Exchange rate</div>
              {loading ? (
                <Skeleton width={100} height="100%" />
              ) : (
                <div className="flex items-center justify-between space-x-4">
                  <div className="text-xs font-bold lg:text-base">
                    {formatNumber(transactionData?.conversion_rate)}
                  </div>
                  <div className="text-xs font-bold lg:text-base">INR</div>
                </div>
              )}
            </div>
          </div>
          <div className="flex items-center justify-between">
            <div className="flex flex-col flex-1">
              <div
                // onClick={() => setTaxStep(!taxStep)}
                className="flex items-center justify-between cursor-pointer"
              >
                <div className="flex items-center text-xs font-bold text-black lg:text-base">
                  <div className="mr-3">
                    <DownIcon />
                  </div>
                  Taxes and fees
                </div>
                {loading ? (
                  <Skeleton width={100} height="100%" />
                ) : (
                  <div className="flex items-center justify-between space-x-4">
                    <div className="text-xs font-bold text-black lg:text-base">
                      {formatNumber(totalPay.toFixed(2))}
                    </div>
                    <div className="text-xs font-bold text-black lg:text-base">INR</div>
                  </div>
                )}
              </div>
              {taxStep === true && (
                <div className="mt-6 ml-[32px] animate-fade duration-0">
                  <div className="flex items-center justify-between mb-5">
                    <div className="flex items-center text-xs font-normal text-black lg:text-base">
                      <div className="mr-3">
                        {/* <Plus fillColor="#B9C9DF" /> */}
                      </div>
                      GST
                    </div>
                    {loading ? (
                      <Skeleton width={100} height="100%" />
                    ) : (
                      <div className="flex items-center justify-between space-x-4">
                        <div className="text-xs font-normal text-black lg:text-base">
                          {formatNumber(transactionData?.total_tax)}
                        </div>
                        <div className="text-xs font-normal text-black lg:text-base">INR</div>
                      </div>
                    )}
                  </div>
                  <div className="flex items-center justify-between mb-5">
                    <div className="flex items-center text-xs font-normal text-black lg:text-base">
                      <div className="mr-3">
                        {/* <Plus fillColor="#B9C9DF" /> */}
                      </div>
                      {purposeCode === "S1301" || purposeCode === "S1302"
                        ? "Bank Fee"
                        : "Bank and Convenience Fee"}
                    </div>
                    {loading ? (
                      <Skeleton width={100} height="100%" />
                    ) : (
                      <div className="flex items-center justify-between space-x-4">
                        <div className="text-xs font-normal text-black lg:font-normal lg:text-base">
                          {formatNumber(transactionData?.nostro_charges)}
                        </div>
                        <div className="text-xs font-normal text-black lg:font-normal lg:text-base">
                          INR
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="flex items-center justify-between space-x-5">
                    <div className="flex items-center text-xs font-normal text-black lg:text-base">
                      <div className="mr-3">
                        {/* <Plus fillColor="#B9C9DF" /> */}
                      </div>
                      <span>NOSTRO</span>
                      <div
                        className="flex ml-2 cursor-pointer"
                        onClick={nostroHandler}
                      >
                        {showOur && <div className={nostro === "our" ? selected : deselcted}>Our</div>}
                        <div className={nostro === "bene" ? selected : deselcted}>Bene</div>
                      </div>
                    </div>
                    {loading ? (
                      <Skeleton width={100} height="100%" />
                    ) : (
                      <div className="flex items-center justify-between space-x-4">
                        <div className="text-xs font-normal text-black lg:font-normal lg:text-base">
                          {formatNumber(transactionData?.nostro_charges_new)}
                        </div>
                        <div className="text-xs font-normal text-black lg:font-normal lg:text-base">
                          INR
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="flex items-center justify-between mt-[18px]">
                    <div className="flex items-center text-xs font-normal text-black lg:text-base">
                      <div className="mr-3">
                        {/* <Plus fillColor="#B9C9DF" /> */}
                      </div>
                      Vendor Fee
                    </div>
                    {loading ? (
                      <Skeleton width={100} height="100%" />
                    ) : (
                      <div className="flex items-center justify-between space-x-4">
                        <div className="text-xs font-normal text-black lg:font-normal lg:text-base">
                          {formatNumber(lastTwoDecimal(vendorFee))}
                        </div>
                        <div className="text-xs font-normal text-black lg:font-normal lg:text-base">
                          INR
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="flex items-center justify-between mt-[18px] relative">
                    <div className="flex items-center text-xs font-normal text-black lg:text-base">
                      <div className="mr-3">
                        {/* <Plus fillColor="#B9C9DF" /> */}
                      </div>
                      <p className="mr-2">
                        TCS
                      </p>
                      <div onMouseEnter={() => setShowInfo(true)} onMouseLeave={() => setShowInfo(false)} className=" w-full">
                        <InfoIcon fillColor="#8D8D8D" />
                      </div>
                      {showInfo && (
                        <div className="absolute top-8 bg-white p-2 rounded shadow-lg w-full">
                          <p className="text-sm text-gray-700">
                            The TCS amount is indicative and may change based on your remitter selection. The final amount will be shown on the review screen before payment.
                          </p>
                        </div>
                      )}
                    </div>
                    {loading ? (
                      <Skeleton width={100} height="100%" />
                    ) : (
                      <div className="flex items-center justify-between space-x-4">
                        <div className="text-xs font-normal text-black lg:font-normal lg:text-base">
                          {transactionData?.tcs ? formatNumber(transactionData.tcs) : 0}
                        </div>
                        <div className="text-xs font-normal text-black lg:font-normal lg:text-base">
                          INR
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="flex items-center gap-0 ml-3 mt-2">
                    <p className=" font-normal text-black lg:text-base">
                      PAN:
                    </p>
                    <p onClick={handlePanBasedClick} className={panDeclarationValue === "" ? panBasedNotSelected : panBasedSelected}>
                      {panDeclarationValue && !isErrorPresent ? `${panDeclarationValue}` : "Add Declaration"}
                    </p>
                    {panDeclarationValue !== "" && <CrossIcon onClick={() => { setPanDeclarationValue(""); setTempPan(""); setIsModalOpen(""); }} className="ml-4 cursor-pointer" width={13} height={13} />}
                  </div>
                </div>
              )}
              <div className="border border-gray-500 rounded-full my-4"></div>
              <div className="flex items-center justify-between mb-4">
                <div className="flex items-center text-xs font-normal text-black lg:text-base">
                  <div className="mr-3">
                    <Equal />
                  </div>
                  <span className="font-bold text-black">You Pay</span>

                  <div className="flex flex-row items-center justify-between ml-3">
                    <button
                      onClick={() =>
                        setRoundOffVal(!roundOffVal)
                      }
                      className={`w-full flex justify-center items-center p-1 rounded-md ${roundOffVal ? "bg-primary-100 text-white cursor-pointer" : "bg-[#E3E3E3] text-black"
                        } ${purposeCodes.includes(purposeCode) ? "cursor-not-allowed opacity-15" : ""}`}
                      disabled={purposeCodes.includes(purposeCode) ? true : false}
                    >
                      Round Off
                    </button>
                  </div>
                </div>
                {loading ? (
                  <Skeleton width={100} height="100%" />
                ) : (
                  <div className="flex items-center justify-between space-x-4">
                    <div className="text-xs font-normal text-black lg:font-bold lg:text-base">
                      {formatNumber(payValue)}
                    </div>
                    <div className="text-xs font-normal text-black lg:font-bold lg:text-base">INR</div>
                  </div>
                )}
              </div>
              {/* {!purposeCodes.includes(purposeCode) && ( */}
              {/* )} */}
              <div className="flex items-center justify-between mt-2">
                <div className="flex items-center text-xs font-normal text-black lg:text-base">
                  <div className="mr-3">
                    <MoneyReceive />
                  </div>
                  <span className="font-bold text-black">They Receive</span>
                </div>
                {loading ? (
                  <Skeleton width={100} height="100%" />
                ) : (
                  <div className="flex items-center">
                    <div className="text-xs font-normal text-black lg:font-bold lg:text-base ml-2 mr-[0.65rem]">
                      {formatNumber(transactionData?.reciepient_recieve)}
                    </div>
                    <div className="text-xs font-normal text-black lg:font-bold lg:text-base">
                      {transactionData.dest_currency}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="submit" className="flex flex-row gap-5 justify-end w-full mt-6 ">
        <div id="download quote" className={`flex items-center justify-center bg-white  p-2 w-fit  hover:scale-105 transition-all text-blue font-roboto text-base font-bold rounded border border-blue-500 ${!purposeCode ? "cursor-not-allowed opacity-15" : "cursor-pointer opacity-100"}`}
          onClick={() => setShowQuoteModal(true)}
        >
          <span className="font-medium text-[18px]"> User quote</span>
        </div>
        <Button
          bgColor={
            isErrorPresent ||
              getSendMoneyErrorMessage(destCurrency, sendingAmount) !== "" ||
              purposeCode === "" ||
              !vendorCode ||
              (typeof vendorCode === "object" && Object.keys(vendorCode).length === 0) ||
              vendorCode.displayName === "" ||
              Number(rate) < 0 ||
              loading
              ? "bg-gray-300"
              : "bg-primary-1050"
          }
          fontStyle={{
            fontFamily: "font-roboto",
            fontSize: "text-base",
            fontWeight: "font-bold",
            fontColor: "text-white",
          }}
          borderStyle={{
            borderRadius: "rounded",
          }}
          onClickHandler={proceedClick}
          className={"flex justify-center py-4 px-14 hover:scale-105 transition-all max-w-40"}
          disabled={
            isErrorPresent ||
            getSendMoneyErrorMessage(destCurrency, sendingAmount) !== "" ||
            purposeCode === "" ||
            !vendorCode ||
            (typeof vendorCode === "object" && Object.keys(vendorCode).length === 0) ||
            vendorCode.displayName === "" ||
            Number(rate) < 0 ||
            String(rate) == "" ||
            loading
          }
        >
          Proceed
        </Button>
      </div>
      {showQuoteModal && (
        <ShareQuoteModal
          onClose={() => {
            setShowQuoteModal(false);
          }}
          downloadQuote={handleDownloadQuoteClick}
          message={message}
          setMessage={setMessage}
        />
      )}
    </div>
  );
};
